import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Schedule {
  id: string;
  name: string;
  contentId: string | null;
  layoutId: string | null;
  playlistId: string | null;
  targetType: 'display' | 'group';
  targetId: string;
  priority: number;
  startDate: string;
  endDate: string | null;
  isActive: boolean;
  isEmergency: boolean;
}

interface ScheduleState {
  items: Schedule[];
  selectedSchedule: Schedule | null;
  loading: boolean;
  error: string | null;
}

const initialState: ScheduleState = {
  items: [],
  selectedSchedule: null,
  loading: false,
  error: null,
};

const scheduleSlice = createSlice({
  name: 'schedules',
  initialState,
  reducers: {
    setSchedules: (state, action: PayloadAction<Schedule[]>) => {
      state.items = action.payload;
      state.loading = false;
      state.error = null;
    },
    setSelectedSchedule: (state, action: PayloadAction<Schedule | null>) => {
      state.selectedSchedule = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
    addSchedule: (state, action: PayloadAction<Schedule>) => {
      state.items.push(action.payload);
    },
    updateSchedule: (state, action: PayloadAction<Schedule>) => {
      const index = state.items.findIndex((s) => s.id === action.payload.id);
      if (index !== -1) {
        state.items[index] = action.payload;
      }
    },
    removeSchedule: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter((s) => s.id !== action.payload);
    },
  },
});

export const {
  setSchedules,
  setSelectedSchedule,
  setLoading,
  setError,
  addSchedule,
  updateSchedule,
  removeSchedule,
} = scheduleSlice.actions;

export default scheduleSlice.reducer;
